import { Controller } from "@hotwired/stimulus"

/**
 * Manages the user menu dropdown in the admin backoffice.
 * Simpler version of the frontend user menu, focused on visibility toggling and clicking outside.
 */
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.clickOutsideHandler = this.clickOutside.bind(this)
  }

  /**
   * Toggles the menu visibility.
   */
  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.remove("hidden")
      document.addEventListener("click", this.clickOutsideHandler)
    } else {
      this.menuTarget.classList.add("hidden")
      document.removeEventListener("click", this.clickOutsideHandler)
    }
  }

  /**
   * Closes the menu if the user clicks outside the controller element.
   */
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
      document.removeEventListener("click", this.clickOutsideHandler)
    }
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler)
  }
}
